import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiPutRequest,
  apiGetByIdRequest,
  apiGetRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { checkAllFieldHasValue } from "src/utils/utils";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const Institution = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [institution, setInstitution] = useState({ name: "" });
  const [sidesRepresented, setSidesRepresented] = useState(null);
  const editMode = rest.kmaction === "edit";
  const [areDictsLoaded, setDictsLoaded] = useState(false);

  let pageTitle =
    rest.kmaction === "new"
      ? "Nowa instytucja"
      : "Edycja instytucji";

  let dictsLoadStatus = {
    sidesRepresented: false,
  };

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getSidesRepresented.path, true)
      .then((data) => {
        disableGlobalLoader();
        setSidesRepresented(data);
        dictsLoadStatus = { ...dictsLoadStatus, sidesRepresented: true };
        setDictsLoaded(checkAllFieldHasValue(dictsLoadStatus, true));
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else {
          navigate("/administracja/slowniki/1");
        }
      });
    if (editMode) {
      enableGlobalLoader();
      apiGetByIdRequest(apiEndpoints.getInstitutionDetails.path, entryId, true)
        .then((data) => {
          disableGlobalLoader();
          setInstitution(data);
        })
        .catch((error) => {
          disableGlobalLoader();
        });
    }
    return () => {};
  }, []);

  const onSubmit = (data) => {
    enableGlobalLoader();

    if (editMode) {
      apiPutRequest(
        apiEndpoints.updateInstitution.path,
        {
          id: entryId,
          name: data.name,
          sideRepresentedId: data.sideRepresented.id,
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/administracja/slowniki/1");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    } else {
      apiPostRequest(
        apiEndpoints.addInstitution.path,
        {
          name: data.name,
          sideRepresentedId: data.sideRepresented.id,
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/administracja/slowniki/1");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    }
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form
            onSubmit={onSubmit}
            sidesRepresented={sidesRepresented}
            institution={institution}
            editMode={editMode}
            areDictsLoaded={areDictsLoaded}
          />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(Institution);
